/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

const channelRowSchema = z.object({
  channel: z.string(),
  installs: z.number(),
  visitors: z.number(),
  conversionRate: z.number(),
});

const templateRowSchema = z.object({
  template: z.string(),
  installs: z.number(),
});

const phraseRowSchema = z.object({
  template: z.string(),
  phrase: z.string(),
  installs: z.number(),
});

const referrerRowSchema = z.object({
  referrerUserId: z.string(),
  referredCount: z.number(),
});

const surfaceRowSchema = z.object({
  channel: z.string(),
  installs: z.number(),
  activated: z.number(),
  activationRate: z.number(),
});

export const getAttributionDashboardV1ResponseDataSchema = z.object({
  period: z.enum(['7d', '30d', 'all']),
  channels: z.array(channelRowSchema),
  seo: z.object({
    templates: z.array(templateRowSchema),
    topPhrases: z.array(phraseRowSchema),
  }),
  kfactor: z.object({
    installers: z.number(),
    referred: z.number(),
    kFactor: z.number(),
    topReferrers: z.array(referrerRowSchema),
  }),
  funnel: z.object({
    surfaces: z.array(surfaceRowSchema),
  }),
});

export type IGetAttributionDashboardV1ResponseData = z.infer<
  typeof getAttributionDashboardV1ResponseDataSchema
>;

export const getAttributionDashboardV1ResponseSchema = createApiResponseSchema(
  getAttributionDashboardV1ResponseDataSchema,
) as z.ZodSchema<IAPI<IGetAttributionDashboardV1ResponseData>>;

export type IGetAttributionDashboardV1Response = IAPI<IGetAttributionDashboardV1ResponseData>;
